/* eslint-disable no-unused-vars */
import axios from "axios";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import _ from "lodash";
import { catchExceptionCallback } from "resbutler-ui/error";
import { getConfig } from "./utilities";

export function clearUsers() {
  _.forIn(window.localStorage, (value, objKey) => {
    if (_.startsWith(objKey, "butler:data")) {
      window.localStorage.removeItem(objKey);
    }
  });
}

export async function loginCustomToken(customToken: string, clientId: string) {
  try {
    const configByEmailResponse = await axios.get(`${ADMIN_URL}/configByClient?clientId=${clientId}`);
    firebase.initializeApp(configByEmailResponse.data.config);
    const userCredential = await firebase.auth().signInWithCustomToken(customToken);
    const functions = window.location.hostname === "localhost" && userCredential.user.displayName === "Paul de Wit" ? `http://localhost:5000/${configByEmailResponse.data.config.projectId}/us-central1` : configByEmailResponse.data.functions;
    window.localStorage.setItem("butler:data", JSON.stringify(Object.assign(configByEmailResponse.data, { functions })));
    window.location.href = "/";
  } catch (error) {
    console.error(error);
    const query = new URLSearchParams(window.location.search);
    if (query.get("returnUrl")) {
      window.location.href = `/login?returnUrl=${query.get("returnUrl")}`;
    } else {
      window.location.href = "/login";
    }
  }
}

export const ADMIN_URL = import.meta.env.VITE_ADMIN_URL;
//export const ADMIN_URL = "https://us-central1-admin-13943.cloudfunctions.net";

export async function login(email: string, pw: string) {
  try {
    const configByEmailResponse = await axios.post(`${ADMIN_URL}/configByEmail`, { email }, { headers: { "project-id": import.meta.env.VITE_PROJECT_ID } });
    clearUsers();
    if (firebase.apps.length) {
      await firebase.app().delete();
    }
    firebase.initializeApp(configByEmailResponse.data.config);
    const userCredential = await firebase.auth().signInWithEmailAndPassword(email, pw);
    const functions = window.location.hostname === "localhost" && userCredential.user.displayName === "Paul de Wit" ? `http://localhost:5000/${configByEmailResponse.data.config.projectId}/us-central1` : configByEmailResponse.data.functions;
    window.localStorage.setItem("butler:data", JSON.stringify(Object.assign(configByEmailResponse.data, { functions })));
    window.sessionStorage.setItem("butler:forceDefaultRestaurant", "1");
    const query = new URLSearchParams(window.location.search);
    if (query.get("returnUrl")) {
      window.location.href = query.get("returnUrl") as any;
    } else {
      window.location.href = "/";
    }
  } catch (error) {
    catchExceptionCallback(error);
  }
}

export async function setActiveRestaurant(restaurantId?: string) {
  const data = getConfig();
  if (!data?.resbutlerApis) return;
  await axios.post(`${data.resbutlerApis}/staff/active-restaurant`, { restaurantId: restaurantId || null }, { headers: { "client-id": data.client } });
  const currentUser = firebase.auth().currentUser;
  if (currentUser) await currentUser.getIdToken(true); // force refresh → new claims
}

export async function readClaims() {
  const currentUser = firebase.auth().currentUser;
  if (!currentUser) return null;
  const { claims } = await currentUser.getIdTokenResult();
  return {
    roles: (claims.roles as number) || 0,
    grants: (claims.grants as Record<string, number>) || {},
    activeRestaurant: (claims.activeRestaurant as string) || "",
    restaurantIds: (claims.restaurantIds as string[]) || [],
  };
}
